import * as React from 'react';

import { Icon, IIconProps } from '@fluentui/react/lib/Icon';

import { getLargeControlText } from './renderLargeControlTextFunction';

export const renderMLRLargeMenuAnchorText = (
  text: string,
  menuIconProps: IIconProps,
  disabled: boolean | undefined,
  containerClassName: string,
  line2ClassName: string,
  iconClassName: string
): JSX.Element => {
  const { line1, line2 } = getLargeControlText(text);
  return (
    <div className={containerClassName}>
      {line1}
      <div className={line2ClassName}>
        {line2}
        <Icon {...menuIconProps} className={iconClassName} style={!!disabled ? disabledIconStyle : undefined} />
      </div>
    </div>
  );
};

/**
 * This represents the style for the disabled icon.
 */
const disabledIconStyle = {
  opacity: 0.4,
};
